import React from 'react'
import { Availability } from '@clear-denver/tpc-bff-client/build/api/tpc-bff/types'
import { Box, Text } from '@clear/design-system'
import { AccessibleLocation } from './AccessibleLocation'

export interface LaneInfo {
  name: string
  description: string
  isAccessible: boolean
  accessibilityMessage: string
  availability: Availability[]
  id: string
  importantInfo?: string
}

export const LaneInfo = ({
  name,
  description,
  isAccessible,
  accessibilityMessage,
  availability,
  importantInfo,
}: LaneInfo) => {
  return (
    <>
      <Text my={1}>{name}</Text>
      <Text>{description}</Text>
      <Box mt={1}>
        {availability.map(({ hours, days }) => (
          <div key={hours} className="mb-1">
            {days && <Text mb={2}>{days}</Text>} <Text mb={2}>{hours}</Text>
          </div>
        ))}
        {importantInfo ? (
          <Text mb={3} color="utilityDarkErrorRed">
            {importantInfo}
          </Text>
        ) : null}
      </Box>
      <AccessibleLocation
        isAccessible={isAccessible}
        accessibilityMessage={accessibilityMessage}
      />
    </>
  )
}
